<!--
 * A Vue component for showing a full-screen button
-->
<template>
    <div v-if="showButtonFullScreen" class="fullscreen"
		 @click="$_toggleFullscreen()"
         :title="isFullScreen ? $t('fullScreenClose') : $t('fullScreenOpen')">
        <div class="innerborder">
            <img src="~@/assets/icons/ic_fluent_arrow_maximize_28_filled.svg" alt="fullscreen" class="center-fullscreen" v-if="!isFullScreen">
            <img src="~@/assets/icons/ic_fluent_arrow_minimize_28_filled.svg" alt="min" class="center-fullscreen" v-else>
        </div>
    </div>
</template>

<script>
    import { isiPhone, isIE, isiPad, isiPadSafari } from './../../../services/utilities/devices';

    export default {
        name: 'FullScreenButton',
        inheritAttrs: false,

        data() {
            return { isFullScreen: false };
        },

        mounted() {
            this.$_addEventListeners();
        },

        beforeDestroy() {
            this.$_removeEventListeners();
        },

        computed: {
            /**
             * Do only show fullscreen button when:
             * - iPhone is not used
             * - Internet Explorer is not used
             * - Ipad with Safari is used (fullscreen is not working in Chrome/Firefox on Ipad)
             */
            showButtonFullScreen() {
                if (isiPhone() || isIE()) {
                    return false;
                }
                return isiPad() && !isiPadSafari() ? false : true;
            },
        },

        methods: {
            /**
             * Receive message from document
             */
            $_addEventListeners() {
                document.addEventListener('fullscreenchange', this.$_fullScreenHandler, false);
                document.addEventListener('mozfullscreenchange', this.$_fullScreenHandler, false);
                document.addEventListener('webkitfullscreenchange', this.$_fullScreenHandler, false);
                document.addEventListener('msfullscreenchange', this.$_fullScreenHandler, false);
            },

            $_removeEventListeners() {
                document.removeEventListener('fullscreenchange', this.$_fullScreenHandler, false);
                document.removeEventListener('mozfullscreenchange', this.$_fullScreenHandler, false);
                document.removeEventListener('webkitfullscreenchange', this.$_fullScreenHandler, false);
                document.removeEventListener('msfullscreenchange', this.$_fullScreenHandler, false);
            },

            $_fullScreenHandler() {
                this.isFullScreen = !!document.fullscreenElement || !!document.mozFullScreenElement || !!document.webkitFullscreenElement || !!document.msFullscreenElement;
            },

            /**
             * Set full-screen on or off
             */
            $_toggleFullscreen() {
                if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
                    if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen();
                    } else if (document.documentElement.msRequestFullscreen) {
                        document.documentElement.msRequestFullscreen();
                    } else if (document.documentElement.webkitRequestFullscreen) {
                        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                    }
                } else {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .fullscreen {
        @include margin-top-fullscreen;
        position: absolute;
        background-color: white;
        border-radius: 50%;
        text-align: center;
        box-shadow: 1px 2px 6px rgba(0,0,0,0.25);
        cursor: pointer;
        width: 40px;
        height: 40px;
        right: 10px;
        z-index: 5;
    }

        .fullscreen em {
            color: #bfbfbf;
            text-align: center;
            min-height: 22px;
            font-size: 12pt !important;
            margin-top: calc(50% - 8px) !important;
        }

        .fullscreen .innerborder {
            border: solid #007AC9 2px;
            border-radius: 50%;
            width: calc(100% - 8px);
            height: calc(100% - 8px);
            margin-left: 4px;
            margin-top: 4px;
        }

    .center-fullscreen {
        margin-top: 4px;
        height: 20px;
    }
</style>
